import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "../../i18n/LangContext";

export const ServiceCard = ({ service, index = 0 }) => {
  const { t } = useLang();
  const Icon = service.icon;
  const [name, desc] = t(`services.${service.id}`);
  return (
    <article
      data-testid={`service-card-${service.id}`}
      className="group relative flex flex-col rounded-xl border border-[#2E2E3A] bg-[#18181F] p-6 transition-colors duration-200 hover:border-[#DC2626]/70 hover:bg-[#1E1E27] rise"
      style={{ animationDelay: `${Math.min(index, 8) * 50}ms` }}
    >
      <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-lg bg-[#DC2626]/15 text-[#DC2626] transition-colors group-hover:bg-[#DC2626] group-hover:text-white">
        <Icon className="h-6 w-6" aria-hidden="true" />
      </div>
      <h3 className="text-xl font-bold uppercase tracking-tight text-white">
        <Link to={`/services/${service.id}`} className="hover:text-[#FACC15]">{name}</Link>
      </h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-gray-400">{desc}</p>
      <Link
        to={`/request?service=${service.id}`}
        data-testid={`service-request-btn-${service.id}`}
        className="mt-6 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-[#FACC15] hover:gap-3 transition-[gap]"
      >
        {t("cta.requestService")} <ArrowRight className="h-4 w-4" aria-hidden="true" />
      </Link>
    </article>
  );
};
